export const createDehydratedState = (
  { bookmakersFromOffers, offers },
  variant,
  ids,
  apiKey
) => {
  const offersWithLogos = offers.map(offer => {
    const bookmaker = bookmakersFromOffers?.find(
      bookmaker => bookmaker?.id === offer?.bookmakerId
    );

    return {
      ...offer,
      bookmaker
    };
  });

  const cacheKey = [
    variant,
    apiKey,
    undefined,
    ids,
    undefined,
    undefined,
    undefined,
    undefined
  ];

  return {
    mutations: [],
    queries: [
      {
        queryHash: JSON.stringify(cacheKey),
        queryKey: cacheKey,
        state: {
          data: offersWithLogos,
          dataUpdateCount: 1,
          dataUpdatedAt: Date.now(),
          error: null,
          errorUpdateCount: 0,
          errorUpdatedAt: 0,
          fetchFailureCount: 0,
          fetchFailureReason: null,
          fetchMeta: null,
          fetchStatus: 'idle',
          isInvalidated: false,
          status: 'success'
        }
      }
    ]
  };
};
